"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mileageReportSchema = exports.payoutSchema = exports.payoutStatusSchema = exports.driverEarningSchema = exports.driverExpenseSchema = exports.walletLedgerEntrySchema = exports.walletAccountSchema = exports.walletAccountStatusSchema = void 0;
const zod_1 = require("zod");
exports.walletAccountStatusSchema = zod_1.z.enum(["active", "suspended", "closed"]);
exports.walletAccountSchema = zod_1.z.object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    ownerId: zod_1.z.string(),
    // Billing account this wallet is linked to (org or user billing).
    accountId: zod_1.z.string().optional(),
    currency: zod_1.z.string().min(3).max(3),
    status: exports.walletAccountStatusSchema,
    balance: zod_1.z.number(),
    pendingBalance: zod_1.z.number(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
});
exports.walletLedgerEntrySchema = zod_1.z.object({
    id: zod_1.z.string(),
    accountId: zod_1.z.string(),
    ts: zod_1.z.string(),
    type: zod_1.z.enum(["credit", "debit"]),
    amount: zod_1.z.number(),
    currency: zod_1.z.string().min(3).max(3),
    refType: zod_1.z.string(),
    refId: zod_1.z.string(),
    meta: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
});
exports.driverExpenseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    driverId: zod_1.z.string(),
    vehicleId: zod_1.z.string().nullable().optional(),
    tripId: zod_1.z.string().nullable().optional(),
    category: zod_1.z.string(),
    amount: zod_1.z.number(),
    currency: zod_1.z.string().min(3).max(3),
    ts: zod_1.z.string(),
    vendor: zod_1.z.string().nullable().optional(),
    receiptUrl: zod_1.z.string().nullable().optional(),
    meta: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
});
exports.driverEarningSchema = zod_1.z.object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    driverId: zod_1.z.string(),
    vehicleId: zod_1.z.string().nullable().optional(),
    tripId: zod_1.z.string().nullable().optional(),
    source: zod_1.z.string(),
    amount: zod_1.z.number(),
    currency: zod_1.z.string().min(3).max(3),
    ts: zod_1.z.string(),
    meta: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
});
exports.payoutStatusSchema = zod_1.z.enum(["pending", "processing", "settled", "failed"]);
exports.payoutSchema = zod_1.z.object({
    id: zod_1.z.string(),
    accountId: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    amount: zod_1.z.number(),
    currency: zod_1.z.string().min(3).max(3),
    destination: zod_1.z.string(),
    status: exports.payoutStatusSchema,
    requestedAt: zod_1.z.string(),
    settledAt: zod_1.z.string().nullable(),
    failureReason: zod_1.z.string().nullable().optional(),
});
exports.mileageReportSchema = zod_1.z.object({
    driverId: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    from: zod_1.z.string(),
    to: zod_1.z.string(),
    businessKm: zod_1.z.number(),
    personalKm: zod_1.z.number(),
    totalKm: zod_1.z.number(),
    trips: zod_1.z.number().int(),
});
